import { useCallback } from "react";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";

export default function ParticleBackground() {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  return (
    <div className="fixed inset-0 z-0">
      <Particles
        init={particlesInit}
        options={{
          fullScreen: {
            enable: true,
            zIndex: 0,
          },

          background: {
            color: "transparent",
          },

          fpsLimit: 60,

          particles: {
            number: {
              value: 120, // 🔥 INCREASED (big difference)
              density: {
                enable: true,
                area: 800,
              },
            },

            color: {
              value: ["#22d3ee", "#38bdf8", "#0ea5e9"], // 🔥 multiple blues
            },

            size: {
              value: { min: 1, max: 4 }, // 🔥 variation
            },

            move: {
              enable: true,
              speed: 1.2,
              direction: "none",
              random: true,
              straight: false,
              outModes: {
                default: "out",
              },
            },

            links: {
              enable: true,
              color: "#38bdf8",
              distance: 140,
              opacity: 0.5, // 🔥 stronger
              width: 1,
            },

            opacity: {
              value: { min: 0.3, max: 0.9 }, // 🔥 more visible
              animation: {
                enable: true,
                speed: 1,
                minimumValue: 0.3,
              },
            },
          },

          interactivity: {
            events: {
              onHover: {
                enable: true,
                mode: "grab", // 🔥 better than repulse for visibility
              },
              resize: true,
            },

            modes: {
              grab: {
                distance: 160,
                links: {
                  opacity: 0.7,
                },
              },
            },
          },

          detectRetina: true,
        }}
      />
    </div>
  );
}